class UpcomingEventItem {
  constructor(
    _id,
    id,
    title,
    startDateTime,
    endDateTime,
    location,
    description,
    category,
    registrationLink,
    featured,
    active,
    image
  ) {
    this._id = _id;
    this.id = id;
    this.title = title;
    // startDateTime/endDateTime may be Date instances or strings
    this.startDateTime = startDateTime;
    this.endDateTime = endDateTime;
    this.location = location || "";
    this.description = description || "";
    this.category = category || "";
    this.registrationLink = registrationLink || "";
    this.featured = !!featured;
    this.active = !!active;
    this.image = image || null;
  }

  static fromJSON(json = {}) {
    // We'll try to normalize a start/end datetime pair.
    // Support these shapes from the API/backends:
    // - startDateTime / endDateTime (ISO string or timestamp)
    // - date (YYYY-MM-DD) + time ("HH:MM" or { start, end })
    // - date (timestamp) + time
    // - legacy: time as single string

    const readValue = (val) => {
      if (val === undefined || val === null || val === "") return "";
      const n = Number(val);
      if (!Number.isNaN(n) && String(val).trim() !== "") {
        // treat as seconds when small, ms when large
        return new Date(n < 1e12 ? n * 1000 : n);
      }
      const dt = new Date(val);
      return isNaN(dt.getTime()) ? val : dt;
    };

    // Prefer explicit startDateTime/endDateTime if provided
    let startDT = readValue(json.startDateTime || json.start_date_time || json.start || "");
    let endDT = readValue(json.endDateTime || json.end_date_time || json.end || "");

    // If not present, try date + time combination
    if (!startDT && json.date) {
      const parsedDate = readValue(json.date);
      // if time is object { start, end }
      if (json.time && typeof json.time === 'object') {
        const s = json.time.start || json.time.from || "";
        const e = json.time.end || json.time.to || "";
        if (s) startDT = (parsedDate instanceof Date) ? new Date(parsedDate.toISOString().slice(0,10) + 'T' + s) : (String(parsedDate) + ' ' + s);
        if (e) endDT = (parsedDate instanceof Date) ? new Date(parsedDate.toISOString().slice(0,10) + 'T' + e) : (String(parsedDate) + ' ' + e);
      } else if (json.time && typeof json.time === 'string') {
        // if time is "HH:MM" or a single time, treat as start
        const s = json.time;
        if (s) startDT = (parsedDate instanceof Date) ? new Date(parsedDate.toISOString().slice(0,10) + 'T' + s) : (String(parsedDate) + ' ' + s);
      } else if (json.eventTime && typeof json.eventTime === 'object') {
        const s = json.eventTime.start || json.eventTime.from || "";
        const e = json.eventTime.end || json.eventTime.to || "";
        if (s) startDT = (parsedDate instanceof Date) ? new Date(parsedDate.toISOString().slice(0,10) + 'T' + s) : (String(parsedDate) + ' ' + s);
        if (e) endDT = (parsedDate instanceof Date) ? new Date(parsedDate.toISOString().slice(0,10) + 'T' + e) : (String(parsedDate) + ' ' + e);
      }
    }

    // Fall back to legacy `time` being a simple start/end object
    if (!startDT && json.time && typeof json.time === 'object') {
      startDT = readValue(json.time.start || json.time.from || "");
      endDT = readValue(json.time.end || json.time.to || "");
    }

    return new UpcomingEventItem(
      json._id || json.id || null,
      json.id || json._id || null,
      json.title || json.name || "",
      startDT,
      endDT,
      json.location || json.venue || "",
      json.description || json.summary || "",
      json.category || "",
      json.registrationLink || json.url || json.link || "",
      !!json.featured,
      !!json.active,
        json.image || json.imageURL || null
    );
  }

  toJSON() {
    return {
      _id: this._id,
      id: this.id,
      title: this.title,
      startDateTime: this.startDateTime ? (this.startDateTime instanceof Date ? this.startDateTime.toISOString() : this.startDateTime) : "",
      endDateTime: this.endDateTime ? (this.endDateTime instanceof Date ? this.endDateTime.toISOString() : this.endDateTime) : "",
      location: this.location,
      description: this.description,
      category: this.category,
      registrationLink: this.registrationLink,
      featured: this.featured,
      active: this.active,
    image: this.image
    };
  }
}

module.exports = UpcomingEventItem;
